module.exports = __webpack_public_path__ + "10af2221c66ada1e62724b2ce6e24cbf.MP3";